import { Footer as FooterComponent } from "@engaging-tech/navigation"
import { usePaths, useRoutes } from "@engaging-tech/routing"
import { getConfig } from "@engaging-tech/ssr-config"
import React from "react"
import styled from "styled-components"

import { ReactComponent as FacebookLogo } from "../../../assets/icons/logos/facebook-logo-icon.svg"
import { ReactComponent as InstagramLogo } from "../../../assets/icons/logos/instagram-logo-icon.svg"
import { ReactComponent as LinkedinLogo } from "../../../assets/icons/logos/linkedin-logo-icon.svg"
import { ReactComponent as PinterestLogo } from "../../../assets/icons/logos/pinterest-logo-icon.svg"
import { ReactComponent as TiktokLogo } from "../../../assets/icons/logos/tiktok-logo-icon.svg"
import { ReactComponent as XLogo } from "../../../assets/icons/logos/x-logo-icon.svg"
import { ReactComponent as YoutubeLogo } from "../../../assets/icons/logos/youtube-logo-icon.svg"
import AppBadges from "./AppBadges"

const styledIcon = Icon => styled(Icon)`
  width: 32px;
  height: 32px;
  transition: fill 0.3s ease;
  opacity: 0.8;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.7;
    opacity: 1;
  }
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`
const FacebookIcon = styledIcon(FacebookLogo)
const InstagramIcon = styledIcon(InstagramLogo)
const XIcon = styledIcon(XLogo)
const LinkedinIcon = styledIcon(LinkedinLogo)
const PinterestIcon = styledIcon(PinterestLogo)
const TiktokIcon = styledIcon(TiktokLogo)
const YoutubeIcon = styledIcon(YoutubeLogo)

const socialMediaLinks = [
  {
    name: <FacebookIcon />,
    url: "https://www.facebook.com/myworkl/"
  },
  {
    name: <InstagramIcon />,
    url: "https://www.instagram.com/workl.com_/"
  },
  {
    name: <XIcon />,
    url: "https://x.com/myworkL"
  },
  {
    name: <LinkedinIcon />,
    url: "https://www.linkedin.com/company/workl"
  },
  {
    name: <PinterestIcon />,
    url: "https://pin.it/4wluMz5OZ"
  },
  {
    name: <TiktokIcon />,
    url: "https://www.tiktok.com/@workl.com"
  },
  {
    name: <YoutubeIcon />,
    url: "https://www.youtube.com/channel/UCQcNZaHDhpGKE--OPjQkjFQ"
  }
]

const Footer = () => {
  const routes = useRoutes().map(route => ({
    ...route,
    description: route.description
  }))

  const paths = usePaths()

  const legalRoutes = routes
    .find(route => route.path === paths.legal.index)
    .children.map(route => ({
      ...route,
      description: route.description
    }))

  const footerRoutes = [
    {
      title: "Company",
      routes: [
        routes.find(route => route.path === paths.aboutUs),
        {
          linkProps: {
            external: true,
            newTab: true
          },
          description: "Contact us",
          path: `${getConfig().workL.public.index}/contact-us`
        }
      ]
    },
    {
      title: "Products",
      routes: [
        {
          linkProps: {
            external: true,
            newTab: true
          },
          description: "WorkL",
          path: `${getConfig().workL.public.index}/home`
        },
        {
          linkProps: {
            external: true,
            newTab: true
          },
          description: "WorkL For Business",
          path: getConfig().worklForBusiness.public.index
        }
      ]
    },
    {
      title: "Legal",
      routes: [
        legalRoutes.find(route => route.path === paths.legal.cookies),
        legalRoutes.find(route => route.path === paths.legal.privacyPolicy),
        legalRoutes.find(route => route.path === paths.legal.termsAndConditions)
      ]
    }
  ]

  return (
    <FooterComponent sections={footerRoutes} socialMedia={socialMediaLinks} badges={AppBadges} boldText />
  )
}

export default Footer
